import { useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import { isAnonymousUser } from 'lib/auth/client-utils';
import Authenticated from './Authenticated';
import Anonymous from './Anonymous';

const UtilityNav = ({ ...profileItem }): JSX.Element => {
  const { data: session } = useSession();
  const isExperienceEditor = useExperienceEditor();
  const [isAnon, setIsAnon] = useState<boolean>(true);

  useEffect(() => {
    // Current session is considered anonymous if user is in experience editor or anon
    setIsAnon(isExperienceEditor || isAnonymousUser(session?.authz_site as string[]));
  }, [session, setIsAnon, isExperienceEditor]);

  return (
    <>
      {isAnon ? (
        <Anonymous profileItem={profileItem} />
      ) : (
        <Authenticated profileItem={profileItem} />
      )}
    </>
  );
};

export default UtilityNav;
